import { Th, Tr } from './headerStyle';

interface IProps {
  headerGroups;
  borderBottom?: boolean;
  borderTop?: boolean;
  lines?: number;
  hasRowSelection?: boolean;
  fullWidth?: boolean;
}

const HeaderView = ({
  headerGroups,
  borderBottom,
  borderTop,
  lines,
  hasRowSelection,
  fullWidth,
}: IProps) => {
  return (
    <>
      {headerGroups.map((headerGroup, index) => (
        <Tr
          key={index}
          borderBottom={borderBottom}
          borderTop={borderTop}
          fullWidth={fullWidth}
          {...headerGroup.getHeaderGroupProps()}
        >
          {headerGroup.headers.map((column, index) => (
            <Th
              key={index}
              lines={lines}
              hasRowSelection={hasRowSelection}
              {...{
                ...column.getHeaderProps(column.getSortByToggleProps()),
                style: {
                  flex: column?.flex || column?.width,
                  minWidth: column.minWidth,
                  padding: column?.padding,
                },
              }}
            >
              {column.render('Header')}
            </Th>
          ))}
        </Tr>
      ))}
    </>
  );
};

export default HeaderView;
